module.exports = __webpack_public_path__ + "static/media/greenTheme-boy.e59284ad.svg";